import Api from '@/services/Index';

const getModelList = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/system/model-list');
}

const getModelColumnList = async (model) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/system/model-column-list/' + model);
}
const jobControl = async (key) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/system/job-control/'+key)
}

export default {
    getModelList,
    getModelColumnList,
    jobControl
}
